/**
 * Get cart sections to render on the cart page.
 *
 * @param productId {number}
 *
 * @returns {({section: string, selector: string, id: string}|{selector: string, id: string})[]}
 */
const getCartSectionsToRender = (productId) => {
  return [
    {
      id: 'cart-drawer',
      section: 'cart-drawer',
      selector: '#shopify-section-cart-drawer',
    },
    {
      id: 'cart-drawer',
      section: 'cart-drawer',
      selector: '#card-shipping',
    },
    {
      id: 'cart-item-counter',
      section: 'cart-item-counter',
      selector: `#cart-item-counter`,
    },
    {
      id: 'cart-item-counter',
      section: 'cart-item-counter',
      selector: `#totalAmount`,
    },
    {
      id: 'cart-usp',
      section: 'cart-usp',
      selector: `#cart-usp`,
    },
  ]
}

export { getCartSectionsToRender }
